import { css, cx } from "@linaria/core"


import { Rotate } from "@/components/Spinner/Spinner.tsx"
import {
  CloseRegular,
  CodeFileRegular,
  CodeTextRegular,
  FigmaRegular,
  FolderRegular,
  RulesRegular,
  SearchRegular,
  SpinnerRegular,
  TerminalRegular,
  TodoRegular
} from "@/icons/Icons.ts"

import type { UIToolCallObservation } from "@/lib/client/generated/TypeDefinitions.ts"

export const ReasoningResult_Icon = (props: { icon: UIToolCallObservation.Icon | null }) => {
  if (props.icon === "COMMIT" || props.icon === "FILE" || props.icon === "IMAGE") {
    return <CodeFileRegular className={SvgIcon12} />
  } else if (props.icon === "DIR") {
    return <FolderRegular className={SvgIcon12} />
  } else if (props.icon === "SYMBOL" || props.icon === "CODE") {
    return <CodeTextRegular className={SvgIcon12} />
  } else if (props.icon === "MEMORY") {
    return <RulesRegular className={SvgIcon12} />
  } else if (props.icon === "CANCEL") {
    return <CloseRegular className={SvgIcon12} />
  } else if (props.icon === "SEARCH") {
    return <SearchRegular className={SvgIcon12} />
  } else if (props.icon === "TERMINAL") {
    return <TerminalRegular className={SvgIcon12} />
  } else if (props.icon === "TODO") {
    return <TodoRegular className={SvgIcon12} />
  } else if (props.icon === "THINKING") {
    return <SpinnerRegular className={cx(SvgIcon12, Rotate)} />
  } else if (props.icon === "FIGMA") {
    return <FigmaRegular className={SvgIcon12} />
  } else {
    return null
  }
}

const SvgIcon12 = css`
  width: 12px;
  height: 12px;

  color: var(--secondary-text-color);
`